<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.9995 2.25C13.9441 2.25009 15.7018 3.39677 16.5845 5.18262L21.2153 14.5537L21.353 14.8564C22.665 18.0063 20.5436 21.7498 17.0767 21.75H6.92236C3.34344 21.75 1.19846 17.761 2.78368 14.5537L7.41454 5.18262L7.59032 4.85547C8.51783 3.25791 10.1763 2.25 11.9995 2.25ZM11.9995 3.75C10.7451 3.75 9.5635 4.44443 8.88818 5.6084L8.75927 5.84766L4.12841 15.2178C2.96774 17.566 4.60551 20.25 6.92236 20.25H17.0767C19.3209 20.2498 20.928 17.7317 19.9712 15.4395L19.8706 15.2178L15.2397 5.84766C14.5935 4.54029 13.3375 3.75009 11.9995 3.75ZM12.7495 17.5H11.2495V15.999H12.7495V17.5ZM12.7495 13H11.2495V7.5H12.7495V13Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
